import { Head, Link } from '@inertiajs/react'
import { Form as InertiaForm } from '@inertiajs/react'
import { useMemo } from 'react'

import { Button } from '@/components/ui/button'

import { UserType } from './types'

interface CommunityOption {
  id: string
  name: string
  location: string
  status: number
}

interface CommunitiesProps {
  user: UserType
  communities: CommunityOption[]
  assigned_community_ids: string[]
}

export default function Communities({
  user,
  communities,
  assigned_community_ids,
}: CommunitiesProps) {
  const assignedIds = useMemo(
    () => new Set(assigned_community_ids.map(String)),
    [assigned_community_ids]
  )

  return (
    <>
      <Head title="Assign communities" />
      <div className="mx-auto md:w-2/3 w-full px-8 pt-8">
        <h1 className="font-bold text-4xl">Assign communities</h1>
        <p className="text-muted-foreground mt-2">
          {user.firstName} {user.lastName} ({user.email})
        </p>

        <InertiaForm
          method="patch"
          action={`/admin/users/${user.id}/communities`}
          transform={(data) => ({ user: data })}
          className="mt-6 space-y-4"
        >
          {() => (
            <>
              <div className="space-y-3">
                {communities.map((community) => {
                  const fieldId = `community-${community.id}`
                  return (
                    <label
                      key={community.id}
                      htmlFor={fieldId}
                      className="flex items-start gap-3 rounded-lg border p-4"
                    >
                      <input
                        id={fieldId}
                        type="checkbox"
                        name="community_ids[]"
                        value={community.id}
                        defaultChecked={assignedIds.has(String(community.id))}
                        className="mt-1"
                      />
                      <span>
                        <span className="block font-medium">
                          {community.name}
                        </span>
                        <span className="block text-sm text-muted-foreground">
                          {community.location} •{' '}
                          {community.status === 1 ? 'Inactive' : 'Active'}
                        </span>
                      </span>
                    </label>
                  )
                })}
                {communities.length === 0 && (
                  <div className="text-sm text-muted-foreground">
                    No communities available.
                  </div>
                )}
              </div>

              <div className="flex gap-3">
                <Button type="submit">Save assignments</Button>
                <Link
                  href="/admin/users"
                  className="rounded-md border px-4 py-2 text-sm font-medium hover:bg-accent"
                >
                  Back to users
                </Link>
              </div>
            </>
          )}
        </InertiaForm>
      </div>
    </>
  )
}
